"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var inStorePaymentFormStyles = makeStyles_1.default(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints, spacing = _a.spacing;
    return ({
        formWrapper: (_b = {
                justifyContent: 'center',
                '& form': {
                    width: '100%',
                },
                '& .form-group.field.field-string.field-error.has-error.has-danger ul li': {
                    display: 'none',
                },
                '& .error-detail': {
                    display: 'none',
                }
            },
            _b[breakpoints.down(breakpoints.values.sm)] = {
                padding: function () { return "0 " + spacing(1.5); },
            },
            _b),
        submitButtonContainer: {
            margin: '20px 0',
        },
        submitButton: {
            marginLeft: 0,
            width: '100%',
        },
    });
}, { name: 'GqlCheckout_InStorePaymentForm' });
exports.default = inStorePaymentFormStyles;
